import { configureStore } from '@reduxjs/toolkit';
import navigationReducer from './Slice/navigationSlice';
import configReducer from './Slice/configSlice';
import metricsReducer from './Slice/metricsSlice';
import loggerReducer from './Slice/loggerSlice';
import toastReducer from './Slice/toastSlice';
import sessionReducer from './Slice/sessionSlice';
import promoterReducer from './Slice/promoterSlice';
import referralReducer from './Slice/referralSlice';

// Agrupamos los reducers en un objeto para reutilizarlo
const rootReducer = {
  navigation: navigationReducer,
  config: configReducer,
  metrics: metricsReducer,
  toast: toastReducer,
  session: sessionReducer,
  logger: loggerReducer,
  promoter: promoterReducer,
  referral: referralReducer,
};

/**
 * Esta es la función que usaremos en nuestros tests.
 * Crea y devuelve una nueva instancia del store cada vez que es llamada.
 */
export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

/**
 * Esta es la instancia del store que tu aplicación principal seguirá usando.
 * Llama a la función setupStore para su creación.
 */
export const store = setupStore({});

